import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasErrors: false,
  errors: [],
  ui: {},
};

export const globalErrorSlice = createSlice({
  name: 'globalError',
  initialState,
  reducers: {
    setGlobalError: (state, action) => {
      const { message } = action.payload;

      if (!state.errors.includes(message)) {
        state.hasErrors = true;
        state.errors.push(message);
      }
    },
    clearErrors: (state) => {
      state.hasErrors = false;
      state.errors = [];
    },
  },
  extraReducers: () => {},
});

export const { setGlobalError, clearErrors } = globalErrorSlice.actions;

export const selectGlobalError = (state) => state.globalError;

export default globalErrorSlice.reducer;
